// extracted by mini-css-extract-plugin
module.exports = {"metaSecondary":"MetaSecondary-module--metaSecondary--2n5dG","samples":"MetaSecondary-module--samples--13FNX"};